export default __webpack_public_path__ + "static/media/xEVLogoTag.08851c90.svg";